<template>
  <div v-if="uploadRecord.file && uploadRecord.file.size" class="is-found-icon">
    <font-awesome-icon
      v-if="!Object.keys(fileUploadStatuses).length"
      class="file-found-icon"
      :icon="['fas', 'check']"
    />
    <spinner-wrapper
      v-else-if="
        fileUploadStatuses[uploadRecord.metadata!.documentId] ===
        FileUploadStatus.UPLOADING
      "
      :size="SpinnerSize.S"
    />
    <font-awesome-icon
      v-else-if="
        fileUploadStatuses[uploadRecord.metadata!.documentId] ===
        FileUploadStatus.UPLOADED
      "
      icon="fa-solid fa-check"
    />
  </div>
  <div v-else class="is-found-icon">
    <font-awesome-icon
      v-if="!Object.keys(fileUploadStatuses).length"
      class="file-not-found-icon"
      :icon="['fas', 'xmark']"
    />
  </div>
</template>

<script lang="ts" setup>
  import {
    FileUploadStatus,
    IFileUploadStatuses,
    IRenditionFile,
    IUploadRecord,
  } from '@/components/MassUpload/MassUpload.types';
  import { SpinnerSize } from '../SpinnerWrapper/SpinnerWrapper.types';

  defineProps<{
    uploadRecord: IUploadRecord | IRenditionFile;
    fileUploadStatuses: IFileUploadStatuses;
  }>();
</script>

<style scoped lang="scss">
  .file-found-icon,
  .file-not-found-icon {
    height: 1.2rem;
    cursor: pointer;
  }
  .file-found-icon {
    color: $markish-green-dark-1;
  }
  .file-not-found-icon {
    color: $brick-red-dark-1;
  }
</style>
